import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const FontSizeSettings = (props) => {
  const [fontSize, setFontSize] = useState(1);
  const fontSizeSettingsRef = useRef();

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--base-font-size",
      fontSize + "rem"
    );
    document.documentElement.style.setProperty("--font-size-scale", fontSize);
  }, [fontSize]);

  return (
    <li
      className="header-meta-sub-menu menu-font-size"
      ref={fontSizeSettingsRef}
    >
      <div className="col">
        <div className="font-size-controls">
          <span className="font-size-from">A</span>
          <div className="slider-wrapper">
            <input
              type="range"
              min={props.min}
              max={props.max}
              step={props.step}
              value={fontSize}
              onChange={(e) => setFontSize(e.target.value)}
              aria-label={"Font Size Change"}
            />
          </div>
          <span className="font-size-to">A</span>
        </div>
      </div>

      <div className="col">
        <span className="sub-menu-label">
          <FormattedMessage id="accessibility.font_size" />
        </span>
      </div>
    </li>
  );
};

FontSizeSettings.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired
};

export default FontSizeSettings;
